module.exports = __webpack_public_path__ + "static/media/Si-Road_high.54fff8d4.png";